/* eslint-disable no-unused-expressions */
import * as Sentry from '@sentry/browser';
import { EEnvironment, getSystemIdentity } from 'utils/system-identity';

export class MonitoringService {
  static init(): void {
    const { hostname } = window.location;

    const { isProduction: shouldEnableSentry } = getSystemIdentity(
      hostname as EEnvironment,
    );

    shouldEnableSentry &&
      Sentry.init({
        dsn: process.env.REACT_APP_CONTENT_DSN,
        integrations: [Sentry.browserTracingIntegration()],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
      });
  }
}
